import { getUserToken } from "../helpers/authHelper";
import api from "../api";


export async function FetchCandidaterescheduleList(interviewid) {

  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/schedule/rescheduled-list/${interviewid}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || ""
    },
  });
}

export async function CandidateRescheduleStatusChange(rescheduleid,status) {
  return await api({
    method: "post",
    url: `${process.env.REACT_APP_API_URL}/admin/schedule/rescheduled-status-change/${rescheduleid}`,
    data: { status },
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || ""
    },
  });
}


